import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { ErrorModalComponent } from '../../../ui/error-modal/error-modal.component';
import { ApiErrorResponse } from '../../../interface/message-error-api.interface';
import { clearSession } from '../../../utils/session.util';


@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
	private getModalRef!: () => ErrorModalComponent;
	private router = inject(Router);

	setModalRef(getter: () => ErrorModalComponent) {
		this.getModalRef = getter;
	}

	handleError(error: unknown): void {
		let err: ApiErrorResponse | undefined;

		if (typeof error === 'object' && error !== null && 'error' in error) {
			err = (error as { error: ApiErrorResponse }).error;
		}

		const title = err?.error?.message?.title || 'Error';
		const desc = err?.error?.message?.description || 'Ha ocurrido un error inesperado';

		// No mostrar modal para errores UNAUTHORIZED
		if (err?.error?.reason !== 'UNAUTHORIZED') {
			this.getModalRef?.()?.show(title, desc);
		}

		if (err?.error?.reason === 'UNAUTHORIZED') {
			clearSession();
			this.router.navigate(['/login']);
		}
	}
}
